// AnalyzePage.js

import React from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  Stack,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";

function AnalyzePage() {
  const location = useLocation();
  const { selectedRowsData } = location.state || { selectedRowsData: [] };

  const names = selectedRowsData.map((row) => row || "Unnamed");

  return (
    <Box
      // maxW="700px"
      mx="auto"
      mt="8"
      p="6"
      boxShadow="lg"
      borderRadius="md"
      bg={useColorModeValue("white", "gray.800")}
    >
      <Heading as="h1" size="xl" mb="6" textAlign="center">
        Analysis Result
      </Heading>
      <Divider mb="6" />
      {names.length > 0 ? (
        <pre>{JSON.stringify(names, null, 2)}</pre>
      ) : (
        <Text>No data to display.</Text>
      )}
    </Box>
  );
}

export default AnalyzePage;
